<div  id="pollSlider-button" class="sidebar-outer">
   
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>